import { GetStaticPropsResult, Redirect } from 'next';
import { createContext } from 'react';
import { fetchJson } from '~/lib/fetch';
import { CommentType } from '~/static/discussions/enums';
import { Deal } from '~/types/deal';

export function getCSRF(): string | null {
  const csrfPrefix = document.cookie?.split('csrftoken=');

  if (csrfPrefix?.length !== 2) {
    return null;
  }

  return csrfPrefix[1].split(';')[0];
}

export function getQuestion(
  dealId: number,
  discussionId: number,
): Promise<Response> {
  return getComment(dealId, CommentType.Question, discussionId);
}

export function getReview(
  dealId: number,
  discussionId: number,
): Promise<Response> {
  return getComment(dealId, CommentType.Review, discussionId);
}

export function getComment(
  dealId: number,
  group: CommentType,
  discussionId: number,
): Promise<Response> {
  return fetchJson(
    `/discussions/api/listcomments/${dealId}/?group=${group}&thread_id=${discussionId}&for_discussion_page=True`,
  );
}

export function redirectToPdp(slug: string): GetStaticPropsResult<Redirect> {
  return {
    redirect: {
      statusCode: 302,
      destination: `/products/${slug}/`,
    },
  };
}

type DealContextType = {
  deal: Deal;
};

export const DealContext = createContext({
  deal: {} as Deal,
} as DealContextType);
